// AGC: Admin empty state — icon + title + optional description and action
import React from 'react'

interface AdminEmptyStateProps {
  icon?: string
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({
  icon = '📭',
  title,
  description,
  action,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center py-16 text-center ${className}`}>
    <span className="text-5xl mb-4">{icon}</span>
    <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-300 mb-1">{title}</h3>
    {description && (
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm">{description}</p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
)
